export enum InsightsLoadingSlidePhase {
    Enter = "enter",
    Idle = "idle",
    Exit = "exit",
}
